<template>
  <span><span class="charge-currency">{{ chargeShowCurrency }}</span>{{ parseFloat(chargeAmount).toFixed(2)}}</span>
</template>

<script>
export default {
  props: {
    chargeAmount: {
      required: true
    },
    chargeCurrency: {
      required: true
    }
  },
  computed: {
    chargeShowCurrency: {
      get() {
        let currencyId = ''
        if(this.chargeCurrency == 'EUR') {
          currencyId = '€'
        } else if(this.chargeCurrency == 'MXN') {
          currencyId = 'MXN $'
        } else if(this.chargeCurrency == 'CAD') {
          currencyId = 'CAD $'
        } else {
          currencyId = '$'
        }
        return currencyId;
      },
      set() {

      }
    }
  }
}
</script>

<style>

</style>
